module.exports = function getResource(label, vars = []) {
    const resources = {
        guestCheckoutMessage: 'Passage en caisse sans compte',
        createAccountCheckoutMessage: 'Créer un compte',
        youCanJoinMessage: 'Vous pouvez vous inscrire à notre programme de fidélisation gratuit après votre passage en caisse.',
        joinBeautyInsiderMessage: 'Adhérez au programme de fidélisation Beauty Insider gratuitement! Ce programme ouvre la porte aux économies, échantillons et plus.',
        continueGuestButton: 'Continuer sans créer de compte',
        createAccountButton: 'Créer un compte',
        checkOutAsAGuestButton: 'Passer à la caisse en tant qu’invité',
        freeBirthdayGift: 'Cadeau\nd’anniversaire gratuit',
        freeCapsBirthdayGift: 'FREE\nBirthday Gift',
        seasonalSavingsEvents: 'Économies\nsaisonnières',
        sampleRewards: 'Échantillons\nde récompenses',
        freeShipping: 'FREE\nShipping',
        bankYourBeautyPoints: `Accumulez des ${vars[0]} points et profitez de nombreux avantages en adhérant à Beauty Insider, notre programme de fidélisation GRATUIT.`,
        bankYourBeautyPointsFree: `Bank those *${vars[0]} points* — and enjoy great benefits, including *FREE standard shipping* — by joining Beauty Insider, our FREE loyalty program.`
    };

    return resources[label];
};
